const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api/";
const API_URL_VERSION = process.env.REACT_APP_API_URL_VERSION || "v1.0/";

export const COMMON_CORE_BASE_URL = BASE_URL + API_URL_VERSION + "app/core/";
export const COMMON_TV_BASE_URL = BASE_URL + API_URL_VERSION + "app/tv/";
